import { faRotateLeft, faSquarePollVertical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useState } from "react";
import { LoadingComponent } from "src/components/shared/LoadingComponent";
import { ProgressBar } from "src/components/shared/ProgressBar";
import TableComponent, { KeyHeader } from "src/components/shared/TableComponent";
import { AppAgentContext } from "src/context/ContextProvider";
import useIgnoreRenderEffect from "src/hooks/useIgnoreRenderEffect";
import { resultsDocumentService } from "src/services/DocumentService";
import { appActions } from "src/store";
import { Document } from "src/types/Document";
import { ModalType } from "src/types/Modal";
import { DateUtil } from "src/utils";
import { DocumentContext } from "./DocumentDetailPageComponent";

export const DocumentHistoryComponent = () => {
  const [totalDocuments, setTotalDocuments] = useState<Document[]>([]);
  const { dispatch: dispatchApp } = useContext(AppAgentContext);
  const { state: { document }} = useContext(DocumentContext);
  const [isLoading, setIsLoading] = useState(false);

  useIgnoreRenderEffect(async () => {
    resultsDocument();
  }, []);

  const resultsDocument = async() => {
    setIsLoading(true);
    if(document.id) {
      const res = await resultsDocumentService(document.id);
      if(res?.success && res.items) {
        const arrayItems = res.items.sort((a, b) => {
            const date1 = new Date(a.updated_at) as Date;
            const date2 = new Date(b.updated_at) as Date;
            return date2.getTime() - date1.getTime();
        });
        setTotalDocuments(arrayItems);
        setIsLoading(false);
      }
    }
    setIsLoading(false);
  }

  if(isLoading) {
    return <LoadingComponent parentHeight="300px" />
  }

  return (
    <div className="p-5">
      <TableComponent 
        items={totalDocuments}
        topActions={
          <div>
              <button
                  onClick={resultsDocument}
                  className={`flex btn btn-sm`}
                  type="button"
              >
                    <FontAwesomeIcon icon={faRotateLeft} />
              </button>
          </div>}
        pagination
        search
        header={[
          {
            type: KeyHeader.KEY,
            label: 'Id',
            key: 'id'
          },
          {
            type: KeyHeader.VALUE,
            label: 'Fecha',
            toValue: (item) => {
              if(item.created_at) {
                  const utcDate = !item.created_at.includes('Z') ? item.created_at + 'Z' : item.created_at;
                  return new DateUtil(new Date(utcDate), 'yyyy-MM-dd hh:mm:ss a').getDate()
              }
              return new DateUtil(new Date(), 'yyyy-MM-dd hh:mm:ss a').getDate()
            },
          },
          {
            type: KeyHeader.KEY,
            label: 'Id del Agente',
            key: 'sbx_ai_agent'
          },
          {
            type: KeyHeader.VALUE,
            label: 'Sentimientos',
            toValue: (item) => {
              const positive = item.getResults()?.sentiment_analysis_resume?.positive?.toFixed(5) || '';
              const neutral = item.getResults()?.sentiment_analysis_resume?.neutral?.toFixed(5) || '';
              const negative = item.getResults()?.sentiment_analysis_resume?.negative?.toFixed(5) || '';

              return (
                <div className="w-[250px]">
                  <ProgressBar data={[
                    {
                      value: positive,
                      color: 'rgb(10, 222, 128)'
                    },
                    {
                      value: neutral,
                      color: 'rgb(251, 146, 60)'
                    },
                    {
                      value: negative,
                      color: 'rgb(248, 113, 113)'
                    },
                  ]} /> 
                </div>  
                )
            }
          },
          {
            type: KeyHeader.VALUE,
            label: 'Estado',
            toValue: (item) => item.getResults()?.status || ''
          },
        ]}
        actions={[
          {
              label: 'Ver Resultados',
              icon: <FontAwesomeIcon icon={faSquarePollVertical} className="text-[18px]" />,
              className: 'btn btn-sm',
              onClick: (item) => {
                dispatchApp(appActions.openModal({
                  type: ModalType.DOCUMENT_RESULTS,
                  data: {
                    title: 'Resultados',
                    onClose: () => dispatchApp(appActions.closeModal(ModalType.DOCUMENT_RESULTS)),
                    data: item.getResults()
                  }
                }))
              },
          },
      ]}
      />
    </div>
  )
}
